import type { V3PayInfo, V3PayStatus } from "../types.v3";

/**
 * Compute pay status from paid vs promised amounts.
 */
export function computePayStatus(pay: Pick<V3PayInfo, "promisedAmount" | "paidAmount">): V3PayStatus {
  const paid = pay.paidAmount ?? 0;

  if (paid >= pay.promisedAmount && pay.promisedAmount > 0) {
    return "paid";
  }

  if (paid > 0) {
    return "partial";
  }

  return "unpaid";
}
